export const getAnchors = (elem: ParentNode): HTMLAnchorElement[] =>
  Array.from(elem.querySelectorAll('*'))
    .flatMap(value =>
      (value.shadowRoot ? getAnchors(value.shadowRoot) : [value]),
    )
    .filter(
      (element: Element): element is HTMLAnchorElement =>
        element.tagName.toUpperCase() === 'A',
    );
